<template>
  <div>
    <div class="row">
      <div class="col-sm">
        <GenericInput
          :inputLabel="inputLabel"
          v-model.number="number"
          :conversionFactors="conversionFactors"
          :negative="negative"
          :noPadding="noPadding"
        />
      </div>
      <div class="col-sm">
        <GenericOutput
          :outputLabel="outputLabel"
          :resultHandler="resultHandler"
          :number="number"
          :conversionFactors="conversionFactors"
          :showSplitter="showSplitter"
          :noPadding="noPadding"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import GenericInput from '../inputs/GenericInput.vue'; // Adjust the path as needed
import GenericOutput from '../inputs/GenericOutput.vue'; // Adjust the path as needed
import { useI18n } from 'vue-i18n';

export default {
  name: 'GenericCalculator',
  components: {
    GenericInput,
    GenericOutput
  },
  props: {
    labelSuffix: {
      type: String,
      required: true,
      default: ''
    },
    conversionFactors: {
      type: Object,
      required: true
    },
    negative: {
      type: Boolean,
      default: false
    },
    resultHandler: Function,
    showSplitter: {
      type: Boolean,
      default: false
    },
    noPadding: Boolean
  },
  setup(props) {
    const { t } = useI18n();
    const number = ref(0);
    const inputLabelSuffix = ref(t('Input'));
    const outputLabelSuffix = ref(t('Output'));
    // const inputLabel = ref(`Input ${props.labelSuffix}`);
    // const outputLabel = ref(`Output ${props.labelSuffix}`);
    const inputLabel = ref(`${inputLabelSuffix.value} ${props.labelSuffix}`);
    const outputLabel = ref(`${outputLabelSuffix.value} ${props.labelSuffix}`);

    return { number, inputLabel, outputLabel };
  }
};
</script>
